import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '@/core/styles/globals.scss'
import 'swiper/scss'
import 'react-toastify/dist/ReactToastify.css'
import App from './App'
import ReactQueryProvider from '@/providers/react-query/provider'
import I18nProvider from '@/providers/i18n/provider'
import ChooseRegionProvider from '@/providers/choose-region/provider'
import { AxeptioIntegration } from '@/core/utils/cookie'
import { ToastContainer } from 'react-toastify'
import ThemeWrapper from '@/core/components/theme-wrapper'


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ReactQueryProvider>
        <I18nProvider>
          <ChooseRegionProvider>
            <AxeptioIntegration />
            <ThemeWrapper>
              <App />
            </ThemeWrapper>
          </ChooseRegionProvider>
        </I18nProvider>
      </ReactQueryProvider>
    </BrowserRouter>
  </React.StrictMode>
)

